module.exports = __webpack_public_path__ + "assets/img/n2.14f4d573.png";